function loadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/util/${view}.vue`
    );
}

function LoginLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/util/login/${view}.vue`
    );
}

function GeneralSignupLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/util/signup/general/${view}.vue`
    );
}

function businessSignupLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/pages/subpage/util/signup/business/${view}.vue`
    );
}

function receiptLoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/components/receipt/${view}.vue`
    );
}

const utilRoutes = [
  /* Util */

  // 일반 로그인 - 메인
  {
    path: '/login',
    name: 'loginGeneral',
    component: LoginLoadView('loginGeneral'),
    meta: {
      onlyGuest: true,
    },
  },

  // 사업자 로그인 - 메인
  {
    path: '/login/business',
    name: 'loginBusiness',
    component: LoginLoadView('loginBusiness'),
    meta: {
      onlyGuest: true,
    },
  },

  // 사업자 로그인 - 아이디 찾기
  {
    path: '/find-id',
    name: 'findId',
    component: LoginLoadView('findId'),
    meta: {
      onlyGuest: true,
    },
  },

  // 사업자 로그인 - 비밀번호 찾기
  {
    path: '/find-pw',
    name: 'findPw',
    component: LoginLoadView('findPw'),
    meta: {
      onlyGuest: true,
    },
  },

  // 일반 회원가입 - 약관
  {
    path: '/signup/general/agreement',
    name: 'signupGeneralAgreement',
    component: GeneralSignupLoadView('signupGeneralAgreement'),
    meta: {
      category: ['회원가입', '일반회원'],
      onlyGuest: true,
    },
  },

  // 사업자 회원가입
  {
    path: '/signup/business/agreement',
    name: 'signupBusinessAgreement',
    component: businessSignupLoadView('signupBusinessAgreement'),
    meta: {
      category: ['회원가입', '사업자회원'],
      onlyGuest: true,
    },
  },
  {
    path: '/signup/business/apply',
    name: 'signupBusinessApply',
    component: businessSignupLoadView('signupBusinessApply'),
    meta: {
      category: ['회원가입', '사업자회원'],
      onlyGuest: true,
    },
  },
  {
    path: '/signup/business/result',
    name: 'signupBusinessResult',
    component: businessSignupLoadView('signupBusinessResult'),
    meta: {
      category: ['회원가입', '사업자회원'],
      onlyGuest: true,
    },
  },

  // 통합검색
  {
    path: '/searchlist',
    name: 'searchlist',
    component: loadView('searchList'),
    meta: {
      category: ['통합검색'],
    },
  },

  // 영수증 템플릿
  {
    path: '/receipt',
    name: 'receiptPrint',
    component: receiptLoadView('receiptPrint'),
    meta: {
      isFullpage: true,
    },
  },
];

export default utilRoutes;
